export default __webpack_public_path__ + "static/media/exit.2e83aebe.mp3";